import { useEffect, useState } from 'react';
import { api } from '../api';
import PageHeader from '../components/PageHeader';

export default function Inventory() {
  const [inventory, setInventory] = useState([]);
  const [productId, setProductId] = useState('');
  const [quantity, setQuantity] = useState('');
  const [operation, setOperation] = useState('increase');
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');

  const load = () => api.getInventory().then(setInventory).catch((e) => setError(e.message));

  useEffect(() => {
    load();
    const interval = setInterval(load, 5000);
    return () => clearInterval(interval);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');
    try {
      const result = await api.adjustInventory({
        productId,
        quantity: Number(quantity),
        operation,
      });
      setMessage(`${result.name} stock updated to ${result.stock}`);
      setQuantity('');
      load();
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div>
      <PageHeader title="Inventory" subtitle="Manage stock levels (synced with LUMORA storefront)" />
      <div className="grid lg:grid-cols-2 gap-8">
        <div className="card">
          <h3 className="font-serif font-medium text-lumora-dark-wood mb-4">Current Stock</h3>
          <div className="space-y-3">
            {inventory
              .filter((p) => p.active)
              .map((p) => (
                <div
                  key={p.id}
                  className="flex justify-between items-center py-2 border-b border-lumora-secondary last:border-0"
                >
                  <span>{p.name}</span>
                  <span className="font-mono text-lumora-wood font-medium">{p.stock}</span>
                </div>
              ))}
          </div>
        </div>
        <form onSubmit={handleSubmit} className="card space-y-4">
          <h3 className="font-serif font-medium text-lumora-dark-wood">Adjust Inventory</h3>
          <select
            value={productId}
            onChange={(e) => setProductId(e.target.value)}
            className="input"
            required
          >
            <option value="">Select Product</option>
            {inventory
              .filter((p) => p.active)
              .map((p) => (
                <option key={p.id} value={p.id}>
                  {p.name} (current: {p.stock})
                </option>
              ))}
          </select>
          <select value={operation} onChange={(e) => setOperation(e.target.value)} className="input">
            <option value="increase">Increase</option>
            <option value="decrease">Decrease</option>
          </select>
          <input
            type="number"
            min="1"
            placeholder="Quantity"
            value={quantity}
            onChange={(e) => setQuantity(e.target.value)}
            className="input"
            required
          />
          {error && <p className="text-red-600 text-sm">{error}</p>}
          {message && <p className="text-green-700 text-sm">{message}</p>}
          <button type="submit" className="btn-primary">
            Save
          </button>
        </form>
      </div>
    </div>
  );
}
